/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import store from '@/store';
import request from '@hb/sharp-request';
import { newGatewayUrl } from '@/constant';

export const update = (): Promise<unknown> => request.postGate(
  'f.user.userDevice.update',
  {
    deviceJson: store.getters['base/devicesJSON'],
    cityInfoJson: store.state.base.cityInfo,
  },
  {
    // 避免显示无意义的干扰信息
    showLoading: undefined,
    baseURL: newGatewayUrl,
  },
);

const UserDeviceApi = {
  update,
};

export default UserDeviceApi;
